module.exports = __webpack_public_path__ + "static/img/2_1_8.09b9c32e.jpg";